<template>
    <div>
        <b-card
            no-body
        >
            <div class="card-header align-items-start">
                <div class="card-group-title">
                    <b-card-title>
                        {{ $t('org.billing.Weekly Cost') }}
                    </b-card-title>
                </div>
                <b-card-actions-container
                    v-if="data.length"
                    class="card-actions-container"
                    @card:collapse="toggleMode"
                />
            </div>
            <b-card-body>
                <template v-if="data.length">
                    <WeeklyHeatmapChart
                        v-if="data.length"
                        ref="container"
                        :svg="svg"
                        :data="data"
                        :weeks="weeks"
                        :dataIfSelected="dataIfSelected"
                        :weekSelected="weekSelected"
                        @select:week="selectWeek"
                        @resize:svg="handleResize"
                        @detail-layer="detailLayer"
                    ></WeeklyHeatmapChart>
                    <WeeklyHeatmapTable
                        v-show="mode === 'table'"
                        :weeks="weeks"
                        :data="data"
                        @detail-layer="detailLayer"
                    ></WeeklyHeatmapTable>
                </template>
                <template v-else>
                    <div class="d-flex justify-content-center align-items-center flex-column text-center">
                        <SVGEmptyIcon/>
                        <span>{{ $t('org.dashboard.No data') }}</span>
                    </div>
                </template>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import BCardActionsContainer from '@/components/BCardActionsContainer'
import WeeklyHeatmapChart from './WeeklyHeatmapChart'
import WeeklyHeatmapTable from './WeeklyHeatmapTable'
import { ref, toRefs, computed } from '@vue/composition-api'
import SVGEmptyIcon from '@/assets/images/empty.svg'
export default {
    components: {
        BCardActionsContainer,
        WeeklyHeatmapChart,
        WeeklyHeatmapTable,
        SVGEmptyIcon
    },
    props: {
        data: {
            type: Array,
            default: function () {
                return []
            }
        },
        status: {
            type: String,
            default: ''
        },
        month: {
            type: String,
            default: ''
        },
        projectIdx: {
            type: Number,
            default: null
        }
    },
    setup (props, context) {
        const svg = ref({
            width: 100,
            height: 250,
            paddingL: 10,
            paddingR: 10,
            paddingT: 25,
            paddingB: 17
        })
        const { data } = toRefs(props)
        const mode = ref('graph')
        const weekSelected = ref(null)
        const dataIfSelected = computed(() => {
            return data.value.filter(item => item.week === weekSelected.value || !weekSelected.value)
        })
        const weeks = computed(() => {
            return dataIfSelected.value.map(item => item.week).filter((obj, pos, arr) => {
                return arr.indexOf(obj) === pos
            }).filter(item => !weekSelected.value || item === weekSelected.value)
        })
        const detailLayer = (date) => context.emit('detail-layer', { date })
        const container = ref(null)
        const handleResize = () => {
            if (container.value) {
                svg.value.width = container.value.$el.clientWidth
            }
        }
        const toggleMode = () => {
            weekSelected.value = null
            mode.value = mode.value === 'graph' ? 'table' : 'graph'
        }
        const selectWeek = (week) => {
            weekSelected.value = weekSelected.value === week ? null : week
        }
        return {
            svg,
            mode,
            container,
            weekSelected,
            dataIfSelected,
            weeks,
            detailLayer,
            handleResize,
            toggleMode,
            selectWeek
        }
    }
}
</script>

<style>
#containerWeeklyHeatmap text.shadow {
    text-shadow: #FFF 2px 2px 10px
}
#containerWeeklyHeatmap .list-enter-active, #containerWeeklyHeatmap .list-leave-active {
    transition: all 1s;
}

#containerWeeklyHeatmap .list-enter {
    opacity: 0;
    transform: translateY(30px);
}

#containerWeeklyHeatmap .list-leave-to  {
    opacity: 0;
    transform: translateX(30px);
}
</style>
